(function(cssUtil) {
  jQuery.extend({

    /* css link toappend*/
    linkCSS: function(cssUrl) {
      // if ($("head").find("link[type='text/css'][href='" + cssUrl + "']").length == 0) {
      //   var link = document.createElement("link");
      //   link.type = "text/css";
      //   link.rel = "stylesheet";
      //   link.href = cssUrl;
      //   document.getElementsByTagName("head")[0].appendChild(link);
      // }
      if (cssUrl) {
        cssUtil.linkCSSArr([cssUrl]);
      }
    },

    /* css link toremove*/
    delLinkCSS: function(cssUrl) {
      // $("head").find("link[type='text/css']").each(function() {
      //   if ($(this).attr("href") == cssUrl) {
      //     $(this).remove();
      //   }
      // });
      if (cssUrl) {
        cssUtil.delLinkCSSArr([cssUrl]);
      }
    },
    linkScript: function(src) {
      if ($("head").find("script[type='text/javascript'][src='" + src + "']").length == 0) {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = src;
        document.getElementsByTagName("head")[0].appendChild(script);
      }
    },
    delScript: function(src) {
      var targetScript = $("head").find("script[type='text/javascript'][src='" + src + "']");
      if (targetScript.length) {
        targetScript.remove();
      }
    },
    linkCSSArr: function(cssUrlArr) {
      if (!window.LinkCSSWillLinkedArr || !$.isArray(window.LinkCSSWillLinkedArr)) {
        window.LinkCSSWillLinkedArr = [];
      }
      $.merge(window.LinkCSSWillLinkedArr, cssUrlArr);

      if (window.LinkCSSWillLinkedArr && window.LinkCSSWillLinkedArr.length != 0) {
        $.each(window.LinkCSSWillLinkedArr, function(key, val) {
          var cssUrl = val;
          var verStr = "?yhtver=" + static_resource_version;
          if (cssUrl.indexOf('?') !== -1) {
            verStr = "&yhtver=" + static_resource_version;
          }
          if ($("head").find("link[type='text/css'][href='" + cssUrl + verStr + "']").length == 0) {
            var link = document.createElement("link");
            link.type = "text/css";
            link.rel = "stylesheet";
            link.href = cssUrl + verStr;
            // alert("link:" + link);
            document.getElementsByTagName("head")[0].appendChild(link);
          }
        });
      }
      window.LinkCSSWillLinkedArr = [];

      setTimeout(function() {
        var winh = $(window).height();
        var bodyh = $("body>#content").height();
        var doch = $(document).height() + $(window).scrollTop();
        // window.console && console.log("modified" + "winh:" + winh + ";doch:" + doch + ";bodyh:" + bodyh);
        if (winh > bodyh) {
          $('html').css('height', '100%');
          $('body').css('height', '100%');
        } else {
          $('html').css('height', '');
          $('body').css('height', '');
        }
        // window.console && console.log("did modified" + "winh:" + winh + ";doch:" + doch + ";bodyh:" + bodyh);

      }, 100);


    },

    delLinkCSSArr: function(cssUrlArr) {
      if (!window.LinkCSSWillCleanedArr || !$.isArray(window.LinkCSSWillCleanedArr)) {
        window.LinkCSSWillCleanedArr = [];
      }
      $.merge(window.LinkCSSWillCleanedArr, cssUrlArr);
      for (var i = 0; i < window.LinkCSSWillCleanedArr.length; i++) {
        var cssUrl = window.LinkCSSWillCleanedArr[i];
        var verStr = "?yhtver=" + static_resource_version;
        if(cssUrl.indexOf('yhtver=') !== -1){
          verStr = '';
        }else if (cssUrl.indexOf('?') !== -1) {
          verStr = "&yhtver=" + static_resource_version;
        }
        window.LinkCSSWillCleanedArr[i] = cssUrl + verStr;
      }
    },



    LinkCSSDidClean: function() {
      //clean cssarr in LinkCSSWillCleanedArr
      if (window.LinkCSSWillCleanedArr && window.LinkCSSWillCleanedArr.length != 0) {
        $("head").find("link[type='text/css']").each(function() {
          var linkstr = $(this).attr("href");
          if ($.inArray(linkstr, window.LinkCSSWillCleanedArr) > -1) {
            $(this).remove();
          }
        });
      }
      window.LinkCSSWillCleanedArr = [];
    }

  })
})($);
module.exports = $;